<template>
  <v-app-bar
    app
    color="#f8fafc"
    height="56"
    extended
    :extension-height="$vuetify.breakpoint.xsOnly ? 52 : 46"
    class="dashboard-topnav desktop-topnav"
  >
    <div class="d-flex align-center">
      <div class="topnav-brand">
        <span class="topnav-brand__mini">{{ $t('tp') }}</span>
        <span class="topnav-brand__name hidden-sm-and-down">{{ $t('tim') }}</span>
      </div>
    </div>

    <v-spacer />

    <template v-slot:extension>
      <div class="topnav-extension">
        <v-divider />
        <div class="topnav-extension__inner">
          <v-tabs
            class="topnav-tabs"
            background-color="transparent"
            color="indigo"
            show-arrows
            optional
          >
            <v-tab
              v-for="(item, i) in navItems"
              :key="`top-tab-${i}`"
              :to="item.to"
              exact
              class="topnav-tab"
            >
              <v-icon left small v-text="item.icon" />
              <span class="topnav-tab__label" v-text="$t(item.title)" />
            </v-tab>
          </v-tabs>
        </div>
      </div>
    </template>

    <v-spacer />
    <!--
    <v-text-field
      :label="$t('search')"
      color="secondary"
      hide-details
      class="mb-2"
      style="max-width: 165px;"
    >
      <template
        v-if="$vuetify.breakpoint.mdAndUp"
        v-slot:append-outer
      >
        <v-btn
          class="mt-n2"
          fab
          small
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
    </v-text-field> -->

    <!-- <div class="mx-3" />

    <v-btn
      min-width="0"
      text
    >
      $ {{ this.$store.state.user.info.balance }} USD
    </v-btn>
    <v-btn
      min-width="0"
      text
    >
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            color="red"
            overlap
          >
            <template v-slot:badge>
              <span class="caption">5</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        nav
      >
        <div>
          <app-bar-item
            v-for="(n, i) in notifications"
            :key="`item-${i}`"
          >
            <v-list-item-title v-text="n" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu> -->

    <v-menu
      bottom
      left
      min-width="200"
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list
        :tile="false"
        flat
        nav
      >
        <template v-for="(p, i) in profile">
          <v-divider
            v-if="p.divider"
            :key="`divider-${i}`"
            class="mb-2 mt-2"
          />

          <app-bar-item
            v-else
            :key="`item-${i}`"
          >
            <v-list-item-title
              @click="logout"
              v-text="p.title"
            />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
  import { VHover, VListItem } from 'vuetify/lib'

  // Utilities
  import { mapActions } from 'vuex'

  export default {
    name: 'DashboardCoreAppBar',

    components: {
      AppBarItem: {
        render (h) {
          return h(VHover, {
            scopedSlots: {
              default: ({ hover }) => {
                return h(
                  VListItem,
                  {
                    attrs: this.$attrs,
                    class: {
                      'black--text': !hover,
                      'white--text secondary elevation-12': hover,
                    },
                    props: {
                      activeClass: '',
                      dark: hover,
                      link: true,
                      ...this.$attrs,
                    },
                  },
                  this.$slots.default
                )
              },
            },
          })
        },
      },
    },

    data: () => ({
      navItems: [
        { icon: 'mdi-account-multiple', title: 'Users', to: '/users' },
        { icon: 'mdi-domain', title: 'Companies', to: '/companies' },
        { icon: 'mdi-devices', title: 'Portals', to: '/portals' },
      ],
      notifications: [
        'Mike John Responded to your email',
        'You have 5 new tasks',
        `You're now friends with Andrew`,
        'Another Notification',
        'Another one',
      ],
      profile: [
        // { title: 'Profile' },
        // { title: 'Settings' },
        // { divider: true },
        { title: 'Log out' },
      ],
    }),

    methods: {
      ...mapActions(['doLogout']),
      logout () {
        this.doLogout()
        this.$router.push('/login')
      },
    },
  }
</script>

<style lang="sass">
  .dashboard-topnav
    border-bottom: 1px solid rgba(15, 23, 42, .10)
    box-shadow: 0 6px 18px rgba(15, 23, 42, .06) !important

  .topnav-brand
    display: inline-flex
    align-items: baseline
    gap: 6px
    font-weight: 800
    letter-spacing: .6px

    &__mini
      color: #3f51b5
      text-transform: uppercase
      font-size: 16px

    &__name
      color: rgba(15, 23, 42, .72)
      text-transform: uppercase
      font-size: 14px

  .topnav-tabs
    max-width: 720px

    // Desktop-app-like segmented tabs
    .v-slide-group__content
      align-items: center
      gap: 6px

    .v-tabs-bar
      height: 40px !important

    .v-tabs-slider
      display: none !important

  .topnav-extension
    width: 100%

  .topnav-extension__inner
    display: flex
    align-items: center
    padding: 4px 12px 6px

  .topnav-tab
    text-transform: none !important
    font-weight: 700
    letter-spacing: 0
    font-size: 13px
    height: 38px !important
    min-width: unset !important
    padding: 0 12px !important
    border-radius: 10px
    color: rgba(15, 23, 42, .72) !important

    &:hover
      background: rgba(15, 23, 42, .05)

  // Mobile: keep nav visible without burger — compact, scrollable, icon-first
  @media (max-width: 600px)
    .topnav-extension__inner
      padding: 4px 6px 6px

    .topnav-tabs
      max-width: 100%

    .topnav-tab
      padding: 0 10px !important
      height: 40px !important

      .v-icon
        margin-right: 0 !important

    .topnav-tab__label
      display: none

  // Force active tab to use theme blue (primary/indigo)
  .topnav-tabs
    .v-tab--active
      color: var(--v-primary-base) !important
      background: rgba(63, 81, 181, .12) !important

      .v-icon
        color: var(--v-primary-base) !important

</style>
